import { render } from "./StatsCherries.vue?vue&type=template&id=3671092e"
import script from "./StatsCherries.vue?vue&type=script&lang=js"
export * from "./StatsCherries.vue?vue&type=script&lang=js"

import "./StatsCherries.vue?vue&type=style&index=0&id=3671092e&style=scoped&lang=css"

import exportComponent from "C:\\Development\\konnektor\\scores\\kon-platform-wallboards-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__